export default {"src":"/_next/static/media/ProfilingIconCategoryActive.36d50e34.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};